import React, { useContext, useEffect, useState } from 'react';
import { BarChart } from '@mui/x-charts/BarChart';
import './RevenueStatistics.css'
import RevenueGraph from './RevenueGraph';
import { dashboardContext } from '../../Dashboard';
import CustomYearSelector from '../../../../Components/CustomYear/CustomYearSelector';
export default function RevenueStatistics() {

    const { year, handleYearChange } = useContext(dashboardContext);

    const [chartWidth, setChartWidth] = useState(300);
    const [chartHeight, setChartHeight] = useState(300);

    // Resize handler to adjust chart  based on screen size
    useEffect(() => {
        const handleResize = () => {

            if (window.innerWidth <= 600) {
                setChartWidth(300); // Smaller width for mobile devices
                setChartHeight(300); // Smaller height for mobile devices
            } else if (window.innerWidth <= 1024) {
                setChartWidth(400); // Medium size for tablets
                setChartHeight(400); // Medium height for tablets
            } else {
                setChartWidth(600); // Larger size for desktops
                setChartHeight(400); // Larger height for desktops
            }
        };

        handleResize();

        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    return (
        <div className='revenue-main-container'>

            <div className='revenue-container'>
                <div>
                    {<span className='revenue-title'>Revenue Statistics</span>}
                </div>
                <div>
                    <CustomYearSelector
                        value={year}
                        onChange={handleYearChange}
                        initialYear={2025}
                    />
                </div>
            </div>
            {/* <BarChart
                xAxis={[{
                    scaleType: 'band', data: ['January', 'February', 'March', 'April'], categoryGapRatio: 0.4,
                    barGapRatio: 0.2
                }]}
                series={[
                    {
                        name: 'Completed Revenue',
                        data: [12000, 15000, 3500, 2900],
                        color: '#006CB8'
                    },
                    {
                        name: 'Ongoing Revenue',
                        data: [8000, 10000, 9500, 12000],
                        color: '#567C09'
                    },


                ]}
                width={chartWidth}
                height={chartHeight}
            /> */}

            <RevenueGraph
            // title="Revenue Statistics"
            // revenueData={[40000, 25000, 15000]}
            // labels={['Site 1', 'Site 2', 'Site 3']}
            // colors={['#42A5F5', '#66BB6A', '#FFA726']}
            />
        </div>
    );
}
